import { InputAdornment } from "@mui/material";
import React, { FC, useEffect, useState } from "react";
import { UseFormRegister, UseFormSetValue } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faCar, faEye, faEyeSlash, faLock } from "@fortawesome/free-solid-svg-icons";
import {
    CheckBox,
    LoginButton,
    LoginInput,
    RememberMe,
    Loading,
    MessageContainer
} from "../Styles";
import FadeLoader from "react-spinners/PulseLoader";
import { FormData } from "../../data/interfaces/dataMessage";
import { LoginError, LoginRequest } from "../../data/interfaces/loginRequest";

interface myProps {
    isOpen: boolean;
    isLoginPaused: boolean;
    register: UseFormRegister<FormData>;
    setLoading: () => void;
    loginData: LoginRequest | undefined;
    errors: any;
    loginError: LoginError;
    setValue: UseFormSetValue<FormData>;
}

const LoginFormComponent: FC<myProps> = (props) => {
    const [showPassword, setShowPassword] = useState(false);
    const [checked, setchecked] = useState(false);
    const handleShowPassword = () => {
        setShowPassword(!showPassword)
    }
    const handleCheckbox = () => {
        setchecked(!checked)

    }

    useEffect(() => {
        props.setValue("RememberMe",checked)
    }, [checked]);

    useEffect(() => {
        if (props.loginData) {
            props.setValue("Dealer", props.loginData.Dealer)
            props.setValue("Password", props.loginData.Password)
            props.setValue("Login", props.loginData.Username)
            setchecked(props.loginData.rememberMe ? true : false)

        }
    }, [props.loginData]);


    return (<div className='input-container'>
        <LoginInput
            id='Dealer'
            label='Dealer'
            size='small'
            error={props.errors.Dealer ? true : false}
            helperText={props.errors.Dealer?.message}
            inputProps={{ maxLength: 51 }}
            {...props.register("Dealer", { required: "Enter your dealer to login.", })}
            InputProps={{
                startAdornment: (
                    <InputAdornment position='start'>
                        <FontAwesomeIcon icon={faCar} />
                    </InputAdornment>
                )
            }}
        />
        <LoginInput
            id='User'
            label='User ID'
            size='small'

            error={props.errors.Login ? true : false}
            helperText={props.errors.Login?.message}
            {...props.register("Login", { required: "Enter your username to login.", })}
            inputProps={{ maxLength: 41 }}
            InputProps={{
                startAdornment: (
                    <InputAdornment position='start'>
                        <FontAwesomeIcon icon={faUser} />
                    </InputAdornment>
                )
            }}
        />
        <LoginInput
            id='Password'
            label='Password'
            size='small'
            type={showPassword ? "text" : "password"}
            error={props.errors.Password ? true : false}
            helperText={props.errors.Password?.message}
            inputProps={{ maxLength: 41 }}
            {...props.register("Password", { required: "Enter your password to login.", })}
            InputProps={{
                startAdornment: (
                    <InputAdornment position='start'>
                        <FontAwesomeIcon icon={faLock} />
                    </InputAdornment>
                ),
                endAdornment: (
                    <InputAdornment position='start' onClick={handleShowPassword}>
                        <FontAwesomeIcon icon={showPassword ? faEye : faEyeSlash} />
                    </InputAdornment>
                )
            }}
        />
        <LoginButton
            variant='contained'
            size='large'
            type="submit"
            disableElevation
            disabled={props.isLoginPaused ? true : false}
        >
            Sign in
            {props.isLoginPaused && (<Loading><FadeLoader color={"white"} size={7} /></Loading>)}
        </LoginButton>
        <RememberMe>
            <div className="remember-me">
                <CheckBox
                    id='RememberMe'
                    checked={checked}
                    onChange={handleCheckbox}
                    inputProps={{ 'aria-label': 'controlled' }}
                    value={checked}
                    name={"RememberMe"}
                /> Remember me
            </div>
        </RememberMe>
        {props.isOpen ?
            (<MessageContainer>
                <p>{props.loginError.Message}</p>
            </MessageContainer>) : (<MessageContainer ></MessageContainer >)
        }
    </div>);
}
export default LoginFormComponent;